import { AnimatePresence } from "framer-motion";
import { useSilver } from "@/context/SilverContext";
import { AudiencePanel } from "@/components/silver/builder/AudiencePanel";
import { EnquiryForm } from "@/components/silver/builder/EnquiryForm";

export function CampaignBuilder() {
  const { builderMode } = useSilver();
  return (
    <div className="glass-strong overflow-hidden" data-testid="campaign-builder">
      <AnimatePresence mode="wait" initial={false}>
        {builderMode === "enquire" ? <EnquiryForm key="enquire" /> : <AudiencePanel key="build" />}
      </AnimatePresence>
    </div>
  );
}
